<template>
    <v-chip class="ma-2" :color="item.active ? `green` : `red`" label outlined small>
        <v-icon small left>{{ item.active ? `mdi-check-circle` : `mdi-circle-off-outline` }}</v-icon>
        {{ item.active ? `Ativo` : `Inativo`}}
    </v-chip>
</template>

<script setup>

import { defineProps } from 'vue'

const props = defineProps({
    item: { type: Object, required: true },
})

</script>